export default __webpack_public_path__ + "static/media/texts_white_icon.16f02c0c.svg";